/**
 * Removes inline citation markers like `[1]`, `[5]`, `[1, 2]`, `[1-3]`, `[1][2]`
 * so TTS doesn't literally read them aloud. Keeps the rest of the sentence intact
 * and normalises whitespace/punctuation around the removed tokens.
 */
export function stripCitationsForSpeech(input: string): string {
    if (!input) return input;
    return input
        // [1], [12], [1, 2], [1,2,3], [1-3], and chains like [1][2]
        .replace(/\[\s*\d+(?:\s*[-,]\s*\d+)*\s*\](?:\s*\[\s*\d+(?:\s*[-,]\s*\d+)*\s*\])*/g, '')
        // collapse space that appears before punctuation after removal: "thing . " -> "thing."
        .replace(/\s+([.,;:!?])/g, '$1')
        // collapse any runs of whitespace created by the removal
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}

export function isWebSearchResponseMode(mode: string | undefined | null): boolean {
    if (mode == null || typeof mode !== 'string') return false;
    const n = mode.trim().toLowerCase().replace(/_/g, '');
    return n === 'websearch';
}

export function wasSynapseUsed(message: { useSynapse?: boolean }): boolean {
    return message.useSynapse === true;
}
